const BadgeIcon = ({ color, icon, clipPath, wrapInClip }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect width="16.7455" height="16.7455" rx="4.65152" fill={color} />
      {wrapInClip ? (
        <g clipPath="url(#clip0_2012_2652)">
          {icon}
          {clipPath}
        </g>
      ) : (
        icon
      )}
    </svg>
  );
};

export default BadgeIcon;
